import { render, staticRenderFns } from "./addresses-page.vue?vue&type=template&id=3f988c52"
import script from "./addresses-page.vue?vue&type=script&lang=js"
export * from "./addresses-page.vue?vue&type=script&lang=js"
import style0 from "./addresses-page.vue?vue&type=style&index=0&id=3f988c52&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports